<template>
  <div class="intro-block px-4 1py-3 1pt-md-5 1pb-md-4 mx-auto1 text-center1">
    <h1 class="display-4">Learn to match outfits</h1>
    <p class="lead mb-5">Develop personal style through experimentation</p>

    <div class="buttons-wrapper">
      <slot name="form"></slot>
    </div>
  </div>
</template>

<script>
import SocialButtons from "@/components/landing/SocialButtons.vue";

export default {
  components: {
    SocialButtons
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import url("https://fonts.googleapis.com/css2?family=Josefin+Slab&display=swap");

.intro-block {
  max-width: 600px;
  margin-top: 75px;

  .buttons-wrapper {
    margin-top: 50px;
  }

  .display-4 {
    font-size: 2.2rem !important;
    color: $primary-blue;
    margin-bottom: 0px;
    font-weight: 400;
    font-family: "Josefin Slab", serif;

    .display-sub {
      font-size: 1.4rem;
      font-weight: 300;
    }
  }

  .lead {
    color: $grey0;
    font-size: 0.9rem;
  }
}

@media (min-width: 576px) {
  .intro-block {
    margin-top: 100px;

    .display-4 {
      font-size: 3.5rem;

      .display-sub {
        font-size: 2.8rem;
        font-weight: 300;
      }
    }

    .lead {
      font-size: 1.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/IntroBlock.vue